import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import bullet from './images/bullet.svg'
import Markdown from '../Markdown'

const RootContainer = styled.div`
	${props => props.spaces === 'smaller' && `
		margin: 0 0;
	`}
`


const Item = styled.div`
	display: flex;
	align-items: baseline;
	
	${props => props.spaces === 'bigger' && `
		margin: 0 0 1rem;
		
		&:last-of-type {
			margin: 0 0 0 0;
		}
	`}
	
	${props => props.spaces === 'smaller' && `
		margin: 0 0;
	`}
	
	${props => props.bold && `
		font-weight: ${props.theme.fontWeights.bold};
	`}
`

const Image = styled.img`
	width: auto;
	height: 0.7rem;
	margin-right: 1rem;
	margin-bottom: 0;
`
Image.defaultProps = {
	alt: '',
	src: bullet,
}

const Text = styled(Markdown)`
	flex: 1;
	
	&, > *:last-child {
		margin-bottom: 0;
	}
`

const List = ({className, items, spaces, bold}) => <RootContainer spaces={spaces} className={className}>
	{items.map(one => <Item spaces={spaces} bold={bold} key={one}>
		<Image/>
		<Text>{one}</Text>
	</Item>)}
</RootContainer>

List.propTypes = {
	className: PropTypes.string,
	items: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
	spaces: PropTypes.oneOf(['bigger', 'smaller']),
	bold: PropTypes.bool,
}

List.defaultProps = {
	className: '',
	spaces: 'bigger',
	bold: false,
}

export default List
